export const PERMISSIONS_ASSIGNMENT_FILTER_TREE_DATA = [
  {
    key: "permissions-assignment",
    title: "",
    checkable: false,
    className: "permissions-management-filter-group",
    children: [
      {key: "has", title: "Has permissions"},
      {key: "none", title: "None assigned"},
    ],
  },
];
